//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueRecaptcha from 'vue-recaptcha';
export default {
  name: 'UserRegister',
  components: { VueRecaptcha },
  data:function(){
    return{
      newReq: {},
      model: null,
      aplTypeOption: [
        {label: 'Perorangan',value: '1',},
        {label: 'Kelompok Orang',value: '2',},
        {label: 'Badan Hukum',value: '3',},
      ],
      slcAplType : {label: 'Perorangan',value: '1',},
      idTypeOption:[
        {label: 'KTP',value: '1',},
        {label: 'Surat Kuasa',value: '2',},
        {label: 'Surat Permohonan',value: '3',},
      ],
      slcIdType: {label: 'KTP',value: '1',},
      accept: false,
      file_upload: '',
      theFile: {},
      selectFile: '',
      formatOption: [],
      alert: false,
    }
  },
  mounted(){
    this.$http.get("/format_info", {})
    .then((result) => {
      for (var i = 0; i < result.data.length; i++) {
        this.formatOption.push(result.data[i].name);
      }
    });
  },
  methods:{
    chgFile(){
      if(this.$refs.scan.files[0])
        this.selectFile = this.$refs.scan.files[0].name
      else
        this.selectFile = ''
    },
    onSubmit () {
      this.$refs.apltype.validate();this.$refs.idtype.validate();this.$refs.noid.validate();
      this.$refs.name.validate();this.$refs.addr.validate();
      this.$refs.phone.validate();this.$refs.empl.validate();
      this.$refs.email.validate();
      this.$refs.desc.validate(); this.$refs.purpose.validate(); this.$refs.format.validate();

      if (this.$refs.apltype.hasError || this.$refs.idtype.hasError || this.$refs.noid.hasError || 
          this.$refs.name.hasError || this.$refs.addr.hasError || 
          this.$refs.phone.hasError || this.$refs.empl.hasError || 
          this.$refs.email.hasError ||
          this.$refs.desc.hasError || this.$refs.purpose.hasError || this.$refs.format.hasError
          ) 
      {
        this.formHasError = true
      }
      else if (this.accept !== true) {
        this.$q.notify({
          color: 'negative', message: 'Anda Harus Menyetujui Pernyataan Terlebih Dahulu!'
        })
      }
      else {
        this.uploadfile()

        this.$q.notify({
          icon: 'done', color: 'positive', message: 'Berhasil registrasi'
        })
      }
    },
    uploadfile(){
      if(!this.$refs.scan.files[0]){
        this.$q.notify({
          color: 'negative', message: 'Anda belum pilih file bukti identitas!'
        })
      }
      else {
        this.theFile = this.$refs.scan.files[0];
        var formData = new FormData();
        formData.append("file", this.theFile);
        formData.append("folder", 'userfile/');

        this.$http.post('/upload.php', formData, {headers: { "Content-Type": "multipart/form-data" }})
        .then(async result => {

          var dt = new Date()
          var year = dt.getFullYear() 
          var month = dt.getMonth()+1
          var day = dt.getDate()
          this.newReq.file = await year.toString() + (month<10? '0'+month:month.toString()) + (day<10? '0'+day:day.toString()) + '_' +this.theFile.name

          this.$http.get("/getlast_reqnumber", {})
          .then((result) => {
              var str = ('000' + (Number(result.data.last_number) + 1))
              var str = str.substring(str.length-3, str.length)
              this.newReq.requestNumber = str

              this.$http.post('/new_request/', this.newReq, {})
                .then (result => {
                  //kirim email notifikasi ke pemohon
                  this.$http.post('/notif/permohonan/'+ result.data,{} )
                    .then (result => {

                    })
                  //history
                  var newhistory = {
                                    t_info_request_id: result.data,
                                    status: 'baru',
                                    pic: this.newReq.name,
                                    action: '-',
                                    receiver: '-',
                                  }
                  this.$http.post('/new_history/', newhistory, {})
                    .then (result => {
                      
                    })

                  this.$router.push('/informasipublik/kategori/1')
                })
          });

        })
      }
    },
  },
  computed:{
    showbutton(){
      return false
    }
  }
}
